import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "24px",
  },
  content: {
    padding: "24px 32px 0px 32px",
    display: "flex",
    flex: 1,
  },
  containerTabs: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowX: "auto",
  },
  containerTabsGrid: {
    display: "flex",
  },
  leftPanelContainer: {
    display: "flex",
  },
  title: {
    color: colors.brandBlue500,
  },
}));

export default styles;

export const DispatchInformation = styled("div")(() => ({
  display: "flex",
  width: "40px",
  height: "40px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "6px",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: `${colors.gray500}14`,
  },
}));

export const DispatchInformationTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: colors.gray800,
  },
}))(Tooltip);

export const DispatchInfoTimezoneWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 2,
}));
